import { render, staticRenderFns } from "./ProjectPrerequisiteRequired.vue?vue&type=template&id=0097bed9&scoped=true&"
import script from "./ProjectPrerequisiteRequired.vue?vue&type=script&lang=js&"
export * from "./ProjectPrerequisiteRequired.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPrerequisiteRequired.vue?vue&type=style&index=0&id=0097bed9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0097bed9",
  null
  
)

export default component.exports